var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "fs-13" },
    [
      _vm.contacts && _vm.contacts.length > 0
        ? _c("div", [
            _c(
              "div",
              _vm._l(_vm.contacts, function(c) {
                return _c(
                  "el-card",
                  {
                    key: c.reference,
                    staticClass: "card contact-card mb-5",
                    class: {
                      selectedContact:
                        _vm.selectedContact &&
                        _vm.selectedContact.reference === c.reference &&
                        _vm.selectable
                    },
                    staticStyle: {
                      "max-width": "300px",
                      "word-break": "break-word",
                      position: "relative"
                    },
                    attrs: { shadow: "never" }
                  },
                  [
                    _c(
                      "el-dropdown",
                      { staticClass: "actions", attrs: { size: "mini" } },
                      [
                        _c("span", { staticClass: "el-dropdown-link" }, [
                          _c("i", { staticClass: "el-icon-more" })
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-dropdown-menu",
                          { attrs: { slot: "dropdown" }, slot: "dropdown" },
                          [
                            _c(
                              "el-dropdown-item",
                              { attrs: { disabled: !_vm.allowEdit } },
                              [
                                !_vm.allowEdit
                                  ? _c("i", { staticClass: "el-icon-lock" })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    on: {
                                      click: function($event) {
                                        return _vm.handleEditContact(c)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("edit")))]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-dropdown-item",
                              { attrs: { disabled: !_vm.allowEdit } },
                              [
                                !_vm.allowEdit
                                  ? _c("i", { staticClass: "el-icon-lock" })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    on: {
                                      click: function($event) {
                                        return _vm.handleAddChannelEndpoint(
                                          c.reference
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("add_channel_endpoint"))
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            c.origin == "RISOLTO"
                              ? _c(
                                  "el-dropdown-item",
                                  { attrs: { divided: "" } },
                                  [
                                    _c(
                                      "span",
                                      {
                                        on: {
                                          click: function($event) {
                                            return _vm.handleRemoveContact(
                                              c.reference
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v(_vm._s(_vm.$t("delete")))]
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "content" }, [
                      _c(
                        "div",
                        { staticClass: "description" },
                        [
                          _c(
                            "div",
                            { staticClass: "disp-flex" },
                            [
                              c.origin == "RISOLTO"
                                ? [
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "dark",
                                          content: _vm.$t("origin_risolto"),
                                          placement: "top"
                                        }
                                      },
                                      [
                                        _c("div", { staticClass: "mr-10" }, [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-user blueColor",
                                            class: {
                                              risoltoColor:
                                                c.origin == "RISOLTO"
                                            }
                                          })
                                        ])
                                      ]
                                    )
                                  ]
                                : [
                                    _c("div", { staticClass: "mr-10" }, [
                                      _c("i", {
                                        staticClass: "el-icon-user blueColor",
                                        class: {
                                          risoltoColor: c.origin == "RISOLTO"
                                        }
                                      })
                                    ])
                                  ],
                              _vm._v(" "),
                              _c("div", [
                                c.full_name
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          c.full_name
                                            ? c.full_name
                                            : "[No full_name available]"
                                        )
                                      )
                                    ])
                                  : _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          c.first_name
                                            ? c.first_name
                                            : _vm.$t("noFirstName")
                                        ) +
                                          " " +
                                          _vm._s(
                                            c.last_name
                                              ? c.last_name
                                              : _vm.$t("noLastName")
                                          )
                                      )
                                    ])
                              ])
                            ],
                            2
                          ),
                          _vm._v(" "),
                          c.contact_type_by_reference
                            ? _c(
                                "div",
                                { staticClass: "disp-flex" },
                                [
                                  _c(
                                    "el-tooltip",
                                    {
                                      staticClass: "item",
                                      attrs: {
                                        effect: "dark",
                                        content: _vm.$t("contact_type"),
                                        placement: "top"
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "mr-10" }, [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-collection-tag blueColor",
                                          class: {
                                            risoltoColor: c.origin == "RISOLTO"
                                          }
                                        })
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          c.contact_type_by_reference
                                            ?.contact_type
                                        )
                                      )
                                    ])
                                  ])
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "disp-flex" }, [
                            _c("div", { staticClass: "mr-10" }, [
                              _c("i", {
                                staticClass: "el-icon-chat-round blueColor",
                                class: { risoltoColor: c.origin == "RISOLTO" }
                              })
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              c.locale
                                ? _c("span", [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t" +
                                        _vm._s(c.locale.substring(0, 2)) +
                                        "\n\t\t\t\t\t\t\t\t"
                                    )
                                  ])
                                : _c("span", [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\tNo Language set\n\t\t\t\t\t\t\t\t"
                                    )
                                  ])
                            ])
                          ]),
                          _vm._v(" "),
                          _vm._l(c.active_endpoints, function(endpoint) {
                            return _c(
                              "div",
                              {
                                key: endpoint.reference,
                                staticStyle: { display: "flex" }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "mr-10" },
                                  [
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "dark",
                                          content:
                                            endpoint.origin == "RISOLTO"
                                              ? _vm.$t("origin_risolto")
                                              : endpoint.deactivated_at !== null
                                              ? _vm.$t("inactive")
                                              : _vm.$t("active"),
                                          placement: "top"
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "blueColor",
                                          class: {
                                            risoltoColor:
                                              endpoint.origin == "RISOLTO",
                                            inActive:
                                              endpoint.deactivated_at !== null,
                                            "el-icon-postcard":
                                              endpoint.channel === "MAIL",
                                            "el-icon-phone":
                                              endpoint.channel === "PHONE",
                                            "el-icon-message":
                                              endpoint.channel === "EMAIL",
                                            "el-icon-edit": !(
                                              endpoint.channel === "MAIL" ||
                                              endpoint.channel === "PHONE" ||
                                              endpoint.channel === "EMAIL"
                                            )
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    endpoint.endpoint_details.invoicing
                                      ? _c(
                                          "el-tooltip",
                                          {
                                            staticClass: "item",
                                            attrs: {
                                              effect: "dark",
                                              content:
                                                _vm.$t(
                                                  "main_contacts.invoicing"
                                                ) +
                                                (endpoint.endpoint_details
                                                  .invoicing_type
                                                  ? " (" +
                                                    endpoint.endpoint_details
                                                      .invoicing_type +
                                                    ")"
                                                  : ""),
                                              placement: "top"
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "el-icon-coin blueColor",
                                              class: {
                                                risoltoColor:
                                                  endpoint.origin == "RISOLTO"
                                              }
                                            })
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    endpoint.endpoint_details.dunning
                                      ? _c(
                                          "el-tooltip",
                                          {
                                            staticClass: "item",
                                            attrs: {
                                              effect: "dark",
                                              content:
                                                _vm.$t(
                                                  "main_contacts.dunning"
                                                ) +
                                                (endpoint.endpoint_details
                                                  .dunning_type
                                                  ? " (" +
                                                    endpoint.endpoint_details
                                                      .dunning_type +
                                                    ")"
                                                  : ""),
                                              placement: "top"
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "el-icon-bell blueColor",
                                              class: {
                                                risoltoColor:
                                                  endpoint.origin == "RISOLTO"
                                              }
                                            })
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  [
                                    endpoint.channel === "PHONE"
                                      ? [
                                          _c("span", [
                                            _vm._v(_vm._s(endpoint.endpoint))
                                          ])
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    endpoint.channel === "EMAIL"
                                      ? [
                                          _c("span", [
                                            _vm._v(_vm._s(endpoint.endpoint))
                                          ])
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    endpoint.channel === "MAIL"
                                      ? [
                                          endpoint.endpoint_details
                                            .street_name_number_box ||
                                          endpoint.endpoint_details.street_name
                                            ? [
                                                endpoint.endpoint_details
                                                  .company_name
                                                  ? _c("div", [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            endpoint
                                                              .endpoint_details
                                                              .company_name
                                                          ) +
                                                          "\n\t\t\t\t\t\t\t\t\t\t"
                                                      )
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                endpoint.endpoint_details
                                                  .street_name
                                                  ? _c(
                                                      "div",
                                                      [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                            _vm._s(
                                                              endpoint
                                                                .endpoint_details
                                                                .street_name
                                                                ? endpoint
                                                                    .endpoint_details
                                                                    .street_name
                                                                : ""
                                                            ) +
                                                            "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                            _vm._s(
                                                              endpoint
                                                                .endpoint_details
                                                                .street_number
                                                                ? endpoint
                                                                    .endpoint_details
                                                                    .street_number
                                                                : ""
                                                            ) +
                                                            "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                        ),
                                                        endpoint
                                                          .endpoint_details
                                                          .post_box
                                                          ? [
                                                              _vm._v(
                                                                "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "post_box"
                                                                    )
                                                                  ) +
                                                                  " " +
                                                                  _vm._s(
                                                                    endpoint
                                                                      .endpoint_details
                                                                      .post_box
                                                                  ) +
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                              )
                                                            ]
                                                          : _vm._e()
                                                      ],
                                                      2
                                                    )
                                                  : endpoint.endpoint_details
                                                      .street_name_number_box
                                                  ? _c("div", [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            endpoint
                                                              .endpoint_details
                                                              .street_name_number_box
                                                          ) +
                                                          "\n\t\t\t\t\t\t\t\t\t\t"
                                                      )
                                                    ])
                                                  : _c("div"),
                                                _vm._v(" "),
                                                _c("div", [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        endpoint
                                                          .endpoint_details
                                                          .zip_code
                                                          ? endpoint
                                                              .endpoint_details
                                                              .zip_code
                                                          : ""
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        endpoint
                                                          .endpoint_details.city
                                                          ? endpoint
                                                              .endpoint_details
                                                              .city
                                                          : ""
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t\t\t\t"
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("div", [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        endpoint
                                                          .endpoint_details
                                                          .iso_country_code
                                                          ? endpoint
                                                              .endpoint_details
                                                              .iso_country_code
                                                          : ""
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t\t\t\t"
                                                  )
                                                ])
                                              ]
                                            : endpoint.endpoint_details.address
                                                .street_name_number_box ||
                                              endpoint.endpoint_details.address
                                                .street_name
                                            ? [
                                                endpoint.endpoint_details
                                                  .address.company_name
                                                  ? _c("div", [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            endpoint
                                                              .endpoint_details
                                                              .address
                                                              .company_name
                                                          ) +
                                                          "\n\t\t\t\t\t\t\t\t\t\t"
                                                      )
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                endpoint.endpoint_details
                                                  .address.street_name
                                                  ? _c(
                                                      "div",
                                                      [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                            _vm._s(
                                                              endpoint
                                                                .endpoint_details
                                                                .address
                                                                .street_name
                                                                ? endpoint
                                                                    .endpoint_details
                                                                    .address
                                                                    .street_name
                                                                : ""
                                                            ) +
                                                            "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                            _vm._s(
                                                              endpoint
                                                                .endpoint_details
                                                                .address
                                                                .street_number
                                                                ? endpoint
                                                                    .endpoint_details
                                                                    .address
                                                                    .street_number
                                                                : ""
                                                            ) +
                                                            "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                        ),
                                                        endpoint
                                                          .endpoint_details
                                                          .address.post_box
                                                          ? [
                                                              _vm._v(
                                                                "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "post_box"
                                                                    )
                                                                  ) +
                                                                  " " +
                                                                  _vm._s(
                                                                    endpoint
                                                                      .endpoint_details
                                                                      .address
                                                                      .post_box
                                                                  ) +
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                              )
                                                            ]
                                                          : _vm._e()
                                                      ],
                                                      2
                                                    )
                                                  : endpoint.endpoint_details
                                                      .address
                                                      .street_name_number_box
                                                  ? _c("div", [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            endpoint
                                                              .endpoint_details
                                                              .address
                                                              .street_name_number_box
                                                          ) +
                                                          "\n\t\t\t\t\t\t\t\t\t\t"
                                                      )
                                                    ])
                                                  : _c("div"),
                                                _vm._v(" "),
                                                _c("div", [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        endpoint
                                                          .endpoint_details
                                                          .address.zip_code
                                                          ? endpoint
                                                              .endpoint_details
                                                              .address.zip_code
                                                          : ""
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        endpoint
                                                          .endpoint_details
                                                          .address.city
                                                          ? endpoint
                                                              .endpoint_details
                                                              .address.city
                                                          : ""
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t\t\t\t"
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("div", [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        endpoint
                                                          .endpoint_details
                                                          .address
                                                          .iso_country_code
                                                          ? endpoint
                                                              .endpoint_details
                                                              .address
                                                              .iso_country_code
                                                          : ""
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t\t\t\t"
                                                  )
                                                ])
                                              ]
                                            : [_c("div")]
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    endpoint.channel !== "MAIL"
                                      ? _c(
                                          "el-tooltip",
                                          {
                                            staticClass: "item",
                                            attrs: {
                                              effect: "dark",
                                              content: _vm.$t(
                                                "shared.copy_to_clipboard"
                                              ),
                                              placement: "top"
                                            }
                                          },
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                staticClass: "clipboard",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.handleCopy(
                                                      endpoint.endpoint,
                                                      $event
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("svg-icon", {
                                                  attrs: {
                                                    "icon-class": "clipboard"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.endpointSelectable
                                      ? _c(
                                          "el-tooltip",
                                          {
                                            staticClass: "item",
                                            attrs: {
                                              effect: "dark",
                                              content: _vm.$t(
                                                "shared.select_this_endpoint"
                                              ),
                                              placement: "top"
                                            }
                                          },
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                staticClass: "clipboard",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.handleSelectContact(
                                                      c,
                                                      endpoint
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "el-icon-aim"
                                                })
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "el-dropdown",
                                      { attrs: { size: "mini" } },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "el-dropdown-link" },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-more"
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-dropdown-menu",
                                          {
                                            attrs: { slot: "dropdown" },
                                            slot: "dropdown"
                                          },
                                          [
                                            _c(
                                              "el-dropdown-item",
                                              {
                                                attrs: {
                                                  disabled: !_vm.allowEdit
                                                }
                                              },
                                              [
                                                !_vm.allowEdit
                                                  ? _c("i", {
                                                      staticClass:
                                                        "el-icon-lock"
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.handleEditChannelEndpoint(
                                                          c.reference,
                                                          endpoint
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.$t("edit"))
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            endpoint.deactivated_at === null
                                              ? _c(
                                                  "el-dropdown-item",
                                                  { attrs: { divided: "" } },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.handleDeactivate(
                                                              endpoint.reference
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "deactivate"
                                                              )
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            endpoint.deactivated_at !== null
                                              ? _c("el-dropdown-item", [
                                                  _c(
                                                    "span",
                                                    {
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.handleReactivate(
                                                            endpoint
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t("reactivate")
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  )
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            endpoint.origin == "RISOLTO"
                                              ? _c("el-dropdown-item", [
                                                  _c(
                                                    "span",
                                                    {
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.handleRemoveChannelEndpoint(
                                                            endpoint.reference
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(_vm.$t("delete"))
                                                      )
                                                    ]
                                                  )
                                                ])
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  2
                                )
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _vm.userInterfaceDetails &&
                          _vm.userInterfaceDetails.custom_field_definitions
                            ? _c("custom-fields-list", {
                                staticClass: "mt-10",
                                attrs: {
                                  "custom-field-definitions":
                                    _vm.userInterfaceDetails
                                      .custom_field_definitions,
                                  "custom-fields": c.custom_fields
                                }
                              })
                            : _vm._e()
                        ],
                        2
                      )
                    ])
                  ],
                  1
                )
              }),
              1
            )
          ])
        : _vm.contacts && _vm.contacts.length === 0
        ? _c("div")
        : _c("div", [_vm._v("\n\t\tLoading...\n\t")]),
      _vm._v(" "),
      _vm.deactivedButUsedEndpoints.length > 0
        ? _c(
            "el-card",
            {
              staticClass: "deactivated content contact-card card",
              staticStyle: { "font-size": "12px" }
            },
            [
              _c("h4", { staticClass: "mt-20" }, [
                _vm._v(_vm._s(_vm.$t("deactivated")))
              ]),
              _vm._v(" "),
              _vm._l(_vm.deactivedButUsedEndpoints, function(endpoint) {
                return _c(
                  "div",
                  { key: endpoint.reference, staticStyle: { display: "flex" } },
                  [
                    _c(
                      "div",
                      [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content: _vm.$t("inactive"),
                              placement: "top"
                            }
                          },
                          [
                            _c("div", { staticClass: "mr-10 pointer" }, [
                              _c("i", {
                                staticClass: "blueColor",
                                class: {
                                  inActive: endpoint.deactivated_at !== null,
                                  "el-icon-postcard":
                                    endpoint.channel === "MAIL",
                                  "el-icon-phone": endpoint.channel === "PHONE",
                                  "el-icon-message":
                                    endpoint.channel === "EMAIL",
                                  "el-icon-edit": !(
                                    endpoint.channel === "MAIL" ||
                                    endpoint.channel === "PHONE" ||
                                    endpoint.channel === "EMAIL"
                                  )
                                }
                              })
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        endpoint.endpoint_details.invoicing
                          ? _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "dark",
                                  content:
                                    _vm.$t("main_contacts.invoicing") +
                                    (endpoint.endpoint_details.invoicing_type
                                      ? " (" +
                                        endpoint.endpoint_details
                                          .invoicing_type +
                                        ")"
                                      : ""),
                                  placement: "top"
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-coin blueColor",
                                  class: {
                                    risoltoColor: endpoint.origin == "RISOLTO"
                                  }
                                })
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        endpoint.endpoint_details.dunning
                          ? _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "dark",
                                  content:
                                    _vm.$t("main_contacts.dunning") +
                                    (endpoint.endpoint_details.dunning_type
                                      ? " (" +
                                        endpoint.endpoint_details.dunning_type +
                                        ")"
                                      : ""),
                                  placement: "top"
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-bell blueColor",
                                  class: {
                                    risoltoColor: endpoint.origin == "RISOLTO"
                                  }
                                })
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "deactivated-endpoint" },
                      [
                        endpoint.channel === "PHONE"
                          ? [_c("span", [_vm._v(_vm._s(endpoint.endpoint))])]
                          : _vm._e(),
                        _vm._v(" "),
                        endpoint.channel === "EMAIL"
                          ? [_c("span", [_vm._v(_vm._s(endpoint.endpoint))])]
                          : _vm._e(),
                        _vm._v(" "),
                        endpoint.channel === "MAIL"
                          ? [
                              endpoint.endpoint_details
                                .street_name_number_box ||
                              endpoint.endpoint_details.street_name
                                ? [
                                    endpoint.endpoint_details.company_name
                                      ? _c("div", [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                endpoint.endpoint_details
                                                  .company_name
                                              ) +
                                              "\n\t\t\t\t\t\t"
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    endpoint.endpoint_details.street_name
                                      ? _c(
                                          "div",
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  endpoint.endpoint_details
                                                    .street_name
                                                    ? endpoint.endpoint_details
                                                        .street_name
                                                    : ""
                                                ) +
                                                "\n\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  endpoint.endpoint_details
                                                    .street_number
                                                    ? endpoint.endpoint_details
                                                        .street_number
                                                    : ""
                                                ) +
                                                "\n\t\t\t\t\t\t\t"
                                            ),
                                            endpoint.endpoint_details.post_box
                                              ? [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        _vm.$t("post_box")
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        endpoint
                                                          .endpoint_details
                                                          .post_box
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              : _vm._e()
                                          ],
                                          2
                                        )
                                      : endpoint.endpoint_details
                                          .street_name_number_box
                                      ? _c("div", [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                endpoint.endpoint_details
                                                  .street_name_number_box
                                              ) +
                                              "\n\t\t\t\t\t\t"
                                          )
                                        ])
                                      : _c("div"),
                                    _vm._v(" "),
                                    _c("div", [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            endpoint.endpoint_details.zip_code
                                              ? endpoint.endpoint_details
                                                  .zip_code
                                              : ""
                                          ) +
                                          "\n\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            endpoint.endpoint_details.city
                                              ? endpoint.endpoint_details.city
                                              : ""
                                          ) +
                                          "\n\t\t\t\t\t\t"
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            endpoint.endpoint_details
                                              .iso_country_code
                                              ? endpoint.endpoint_details
                                                  .iso_country_code
                                              : ""
                                          ) +
                                          "\n\t\t\t\t\t\t"
                                      )
                                    ])
                                  ]
                                : endpoint.endpoint_details.address
                                    .street_name_number_box ||
                                  endpoint.endpoint_details.address.street_name
                                ? [
                                    endpoint.endpoint_details.address
                                      .company_name
                                      ? _c("div", [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                endpoint.endpoint_details
                                                  .address.company_name
                                              ) +
                                              "\n\t\t\t\t\t\t"
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    endpoint.endpoint_details.address
                                      .street_name
                                      ? _c(
                                          "div",
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  endpoint.endpoint_details
                                                    .address.street_name
                                                    ? endpoint.endpoint_details
                                                        .address.street_name
                                                    : ""
                                                ) +
                                                "\n\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  endpoint.endpoint_details
                                                    .address.street_number
                                                    ? endpoint.endpoint_details
                                                        .address.street_number
                                                    : ""
                                                ) +
                                                "\n\t\t\t\t\t\t\t"
                                            ),
                                            endpoint.endpoint_details.address
                                              .post_box
                                              ? [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        _vm.$t("post_box")
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        endpoint
                                                          .endpoint_details
                                                          .address.post_box
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              : _vm._e()
                                          ],
                                          2
                                        )
                                      : endpoint.endpoint_details.address
                                          .street_name_number_box
                                      ? _c("div", [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                endpoint.endpoint_details
                                                  .address
                                                  .street_name_number_box
                                              ) +
                                              "\n\t\t\t\t\t\t"
                                          )
                                        ])
                                      : _c("div"),
                                    _vm._v(" "),
                                    _c("div", [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            endpoint.endpoint_details.address
                                              .zip_code
                                              ? endpoint.endpoint_details
                                                  .address.zip_code
                                              : ""
                                          ) +
                                          "\n\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            endpoint.endpoint_details.address
                                              .city
                                              ? endpoint.endpoint_details
                                                  .address.city
                                              : ""
                                          ) +
                                          "\n\t\t\t\t\t\t"
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            endpoint.endpoint_details.address
                                              .iso_country_code
                                              ? endpoint.endpoint_details
                                                  .address.iso_country_code
                                              : ""
                                          ) +
                                          "\n\t\t\t\t\t\t"
                                      )
                                    ])
                                  ]
                                : [_c("div")]
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "el-dropdown",
                          { attrs: { size: "mini" } },
                          [
                            _c("span", { staticClass: "el-dropdown-link" }, [
                              _c("i", { staticClass: "el-icon-more" })
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-dropdown-menu",
                              { attrs: { slot: "dropdown" }, slot: "dropdown" },
                              [
                                endpoint.deactivated_at !== null
                                  ? _c("el-dropdown-item", [
                                      _c(
                                        "span",
                                        {
                                          on: {
                                            click: function($event) {
                                              return _vm.handleReactivate(
                                                endpoint
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("reactivate")) +
                                              " "
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      2
                    )
                  ]
                )
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "el-button",
            {
              staticClass: "button",
              attrs: { disabled: !_vm.allowEdit, type: "text" },
              on: { click: _vm.handleAddContact }
            },
            [
              _c("i", { staticClass: "el-icon-plus" }),
              _vm._v(" " + _vm._s(_vm.$t("add_contact"))),
              !_vm.allowEdit
                ? _c("span", [_c("i", { staticClass: "el-icon-lock" })])
                : _vm._e()
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("contact-dialog", {
        attrs: {
          participant: _vm.selectedParticipantStore,
          "legal-entity": _vm.legalEntity,
          recipient: _vm.recipient,
          contact: _vm.contactDialogContact ? _vm.contactDialogContact : null,
          visible: _vm.contactDialogVisible,
          "dialog-close": () => {
            _vm.contactDialogVisible = false
            _vm.contactDialogContact = null
          }
        }
      }),
      _vm._v(" "),
      _c("channel-endpoint-dialog", {
        attrs: {
          participant: _vm.selectedParticipantStore,
          recipient: _vm.recipient,
          "legal-entity": _vm.legalEntity,
          contact: _vm.channelEndpointDialogContact
            ? _vm.channelEndpointDialogContact
            : null,
          endpoint: _vm.channelEndpointDialogEndpoint
            ? _vm.channelEndpointDialogEndpoint
            : null,
          visible: _vm.channelEndpointDialogContact ? true : false,
          "dialog-close": () => {
            _vm.channelEndpointDialogContact = null
            _vm.channelEndpointDialogEndpoint = null
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }